import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 74267 106085"
    {...props}
  >
    <path
      d="M24920 89043h3462v17042H11508c-3630 0-6446-987-8471-2987C1012 101097 0 98750 0 96033c0-1729 642-4025 1950-6890 1309-2865 2742-5113 4274-6769 6422-6644 12201-12348 17363-17115 1771-1626 3369-3065 4795-4311v23486c-1130 1289-2286 2831-3462 4609zm20965 0h16799c3779 0 6644 767 8620 2323 1976 1531 2963 3630 2963 6272 0 2348-791 4348-2347 6002-1580 1630-3950 2445-7137 2445H45885V89043zm0-43107c1983-2335 3535-4719 4671-7154 1359-2963 2050-5877 2050-8718 0-3087-740-5854-2197-8299-1179-1947-2688-3531-4524-4782V100c3502 572 6684 1487 9537 2746 3383 1556 6373 3681 8916 6373 2569 2716 4570 5828 5977 9385 1434 3532 2149 7212 2149 11016 0 6001-1482 11434-4445 16324-2965 4891-6002 8745-9089 11510-2726 2444-7068 6135-13045 11046V45936zM28382 15751c-2798 1372-5188 3581-7167 6631-494 716-1309 2692-2445 5929-1136 3234-2396 5730-3828 7459-1407 1728-3508 2617-6248 2617-2421 0-4422-814-6002-2395-1605-1582-2396-3754-2396-6521 0-3310 740-6791 2247-10398 1483-3630 3730-6916 6693-9854 2965-2939 6718-5311 11288-7113 2396-951 5018-1654 7858-2106v15751z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
